import moment from "moment";
import { getCurrentDate } from "./helper-functions";
import { gtcTabsEnum } from "components/side-bar/sidebarEnum";
export const PRODUCTION = "production";
export const DEVELOPMENT = "development";
// This is for staging
export const API_DEV_URL = "https://uattdc.trademo.com/trademo";
//   "https://uattdc.trademo.com/trademo";
export const API_INTEL_URL =
  // "https://staging1.trademo.com/trademo";
  "https://uat.trademo.com/trademo";
export const API_UMS_URL = "https://uatusermanagement.trademo.com/";
export const API_CLASSIFIER_URL = "https://uathsclassificationapi.trademo.com";
export const RFI_BASE_URL = "https://uatrfi-be.trademo.com";
export const PARTNER_MASTER_BASE_URL = "https://uatpartner.trademo.com/trademo";
export const RPS_API_BASE_URL = "https://uatrps.trademo.com/trademo";

export const REACT_APP_UMS_URL = "http://localhost:3020/";
export const LOCAL_ACCOUNTS_URL = "http://localhost:3002/";
export const LOCAL_INTEL_URL = "http://localhost:5173/";
export const LOCAL_SOURCE_ATLAS_URL = "http://localhost:5173/";
export const LOCAL_SANCTIONS_URL = "http://localhost:3000/";
export const LOCAL_PAYMENTS_URL = "http://localhost:3004/";
export const LOCAL_WEBSITE_URL = "http://localhost:3011/";
export const LOCAL_COMPLIANCE_URL = "http://localhost:3012/";
export const LOCAL_ESG_URL = "http://localhost:3009/";
export const LOCAL_SUPPLY_CHAIN_URL = "http://localhost:3010";
export const LOCAL_TRADE_MAP_URL = "http://localhost:3000";
export const LOCAL_HS_CODE_CLASSIFICATION_URL = "http://localhost:3025";
export const LOCAL_WATCH_URL = "http://localhost:3016";
export const LOCAL_PRODUCT_MASTER_URL = "http://localhost:3017/";
export const LOCAL_USER_MANAGEMENT_SYSTEM_URL = "http://localhost:3020";
export const LOCAL_FIN_SCREENER = "http://localhost:3005";

// End of the above code
// This is for production
// export const API_DEV_URL = "https://compliance.trademo.com/trademo";
// End of the above code

export const PROD_INTEL_URL = "https://intel.trademo.com/search-shipments";
export const API_DEV_INTEL_URL = "http://staging.trademo.com/trademo";
export const API_PROD_INTEL_URL = "https://trademo.com/trademo";
// export const sessionId = "9a6e0518-65f7-4d15-a328-eb97cb4eb7b3";

export const tradeComplianceBucket = "https://tdcstorage.trademo.com/";
export const greNotes = "https://tdcstorage.trademo.com/WCO/GRI.pdf";
export const DATE_FORMAT = "MMM DD, YYYY";
export const displayDateTime = (date) => `${moment.utc(date).utc(true).format("MMM DD, YYYY hh:mm:ss")} (UTC)`;
export const ERROR_MESSAGE = "Something went wrong!";

//reusable variables

// styles for data table
export const customStylesTable = {
  table: {
    style: {
      border: "1px solid #eaecf0",
      borderRadius: "4px",
    },
  },

  headCells: {
    style: {
      backgroundColor: "#eaecf0",
      border: "1px solid #eaecf0",
      borderBottom: "none",
      color: "#667085",
      fontSize: "13px",
      fontWeight: "500",
      lineHeight: "1.4",
    },
  },

  rows: {
    style: {
      borderTop: "none",
    },
  },
  cells: {
    style: {
      paddingLeft: "15px", // override the cell padding for data cells
      fontSize: "13px",
      color: "#101828",
      lineHeight: "1.4",
    },
  },
};

export const customStylesSelectClassify = {
  control: (base, state) => ({
    ...base,
    height: "44px",

    backgroundColor: "#fff",
    opacity: 1,
    borderRadius: "4px",
    fontSize: "14px",
    width: "100%",
    color: "#212529",
    border: state.isFocused ? "solid 1px #7143f1" : "solid 1px #d0d5dd",
    //marginBottom:"2px",
    boxShadow: state.isFocused ? "0 0 0 2px rgb(108 56 255 / 20%)" : "none",
    "&:hover": {
      boxShadow: "0 0 0 2px rgb(108 56 255 / 20%)",
      border: "solid 1px #7143f1",
    },
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    color: "#212529",
    padding: "8px",
    width: "100%",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "rgba(111, 8, 241, 0.1)" : null,
    color: isDisabled ? null : isSelected ? "#212529" : isFocused ? "#212529" : null,
    cursor: "pointer !important",
    marginBottom: "8px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#212529 !important",
    fontWeight: "500",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};

// custom style for select
export const customStylesSelect = {
  control: (base, state) => ({
    ...base,
    height: "44px",
    backgroundColor: "#eaecf0",
    borderRadius: "4px",
    fontWeight: "500",
    fontSize: "14px",
    width: "100%",
    color: "#101828 !important",
    border: "none",
    boxShadow: state.isFocused ? "0px 0px 0px 2px #7143f1" : "none",
    "&:hover": {
      border: "none",
      boxShadow: "none",
    },
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    color: "#101828 !important",
    padding: "8px",
    width: "100%",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "rgba(111, 8, 241, 0.1)" : null,
    color: isDisabled ? null : isSelected ? "#101828 !important" : isFocused ? "#101828 !important" : null,
    cursor: "pointer !important",
    marginBottom: "8px",
  }),
};

// dummy data for creating Data table
export const data = [
  {
    _id: "Mi9kyIEBGMMCFteWDnVA",
    _source: {
      country_of_import: { country_iso_code: "US", name: "United States of America" },
      country_of_manufacture: { country_iso_code: "AD", name: "Andorra" },
      country_of_export: { country_iso_code: "AD", name: "Andorra" },
      hscode: "3905300000",
      control_type: "Import Prohibition",
      controlling_authority: "U.S. Environmental Protection Agency (EPA)",
      scope_of_control: "Transboundary movements of wastes between the Organisation for Economic Co-operation and Development (OECD) member countries",
      exceptions: "",
      rates: "",
      notes:
        "Decision of the Council on the Control of Transboundary Movements of Wastes Destined for Recovery Operations (OECD-Legal-0266) including the waste lists (green and amber)",
      reference: "Organization for Economic Cooperation and Development (OECD)",
      effective_date_from: "2022-01-01",
      status: "A",
      effective_date_to: "2050-12-31",
      updated_in_db_date: "2022-07-04",
      is_taxable: true,
    },
  },
  {
    _id: "Mi9kyIEBGMMCFteWDnVA",
    _source: {
      country_of_import: { country_iso_code: "US", name: "United States of America" },
      country_of_manufacture: { country_iso_code: "AD", name: "Andorra" },
      country_of_export: { country_iso_code: "AD", name: "Andorra" },
      hscode: "3905300000",
      control_type: "Import Prohibition",
      controlling_authority: "U.S. Environmental Protection Agency (EPA)",
      scope_of_control: "Transboundary movements of wastes between the Organisation for Economic Co-operation and Development (OECD) member countries",
      exceptions: "",
      rates: "",
      notes:
        "Decision of the Council on the Control of Transboundary Movements of Wastes Destined for Recovery Operations (OECD-Legal-0266) including the waste lists (green and amber)",
      reference: "Organization for Economic Cooperation and Development (OECD)",
      effective_date_from: "2022-01-01",
      status: "A",
      effective_date_to: "2050-12-31",
      updated_in_db_date: "2022-07-04",
      is_taxable: true,
    },
  },
  {
    _id: "Mi9kyIEBGMMCFteWDnVA",
    _source: {
      country_of_import: { country_iso_code: "US", name: "United States of America" },
      country_of_manufacture: { country_iso_code: "AD", name: "Andorra" },
      country_of_export: { country_iso_code: "AD", name: "Andorra" },
      hscode: "3905300000",
      control_type: "Import Prohibition",
      controlling_authority: "U.S. Environmental Protection Agency (EPA)",
      scope_of_control: "Transboundary movements of wastes between the Organisation for Economic Co-operation and Development (OECD) member countries",
      exceptions: "",
      rates: "",
      notes:
        "Decision of the Council on the Control of Transboundary Movements of Wastes Destined for Recovery Operations (OECD-Legal-0266) including the waste lists (green and amber)",
      reference: "Organization for Economic Cooperation and Development (OECD)",
      effective_date_from: "2022-01-01",
      status: "A",
      effective_date_to: "2050-12-31",
      updated_in_db_date: "2022-07-04",
      is_taxable: true,
    },
  },
  {
    _id: "Mi9kyIEBGMMCFteWDnVA",
    _source: {
      country_of_import: { country_iso_code: "US", name: "United States of America" },
      country_of_manufacture: { country_iso_code: "AD", name: "Andorra" },
      country_of_export: { country_iso_code: "AD", name: "Andorra" },
      hscode: "3905300000",
      control_type: "Import Prohibition",
      controlling_authority: "U.S. Environmental Protection Agency (EPA)",
      scope_of_control: "Transboundary movements of wastes between the Organisation for Economic Co-operation and Development (OECD) member countries",
      exceptions: "",
      rates: "",
      notes:
        "Decision of the Council on the Control of Transboundary Movements of Wastes Destined for Recovery Operations (OECD-Legal-0266) including the waste lists (green and amber)",
      reference: "Organization for Economic Cooperation and Development (OECD)",
      effective_date_from: "2022-01-01",
      status: "A",
      effective_date_to: "2050-12-31",
      updated_in_db_date: "2022-07-04",
      is_taxable: true,
    },
  },
  {
    _id: "Mi9kyIEBGMMCFteWDnVA",
    _source: {
      country_of_import: { country_iso_code: "US", name: "United States of America" },
      country_of_manufacture: { country_iso_code: "AD", name: "Andorra" },
      country_of_export: { country_iso_code: "AD", name: "Andorra" },
      hscode: "3905300000",
      control_type: "Import Prohibition",
      controlling_authority: "U.S. Environmental Protection Agency (EPA)",
      scope_of_control: "Transboundary movements of wastes between the Organisation for Economic Co-operation and Development (OECD) member countries",
      exceptions: "",
      rates: "",
      notes:
        "Decision of the Council on the Control of Transboundary Movements of Wastes Destined for Recovery Operations (OECD-Legal-0266) including the waste lists (green and amber)",
      reference: "Organization for Economic Cooperation and Development (OECD)",
      effective_date_from: "2022-01-01",
      status: "A",
      effective_date_to: "2050-12-31",
      updated_in_db_date: "2022-07-04",
      is_taxable: true,
    },
  },
];

// Navigation data for compliance
export const navigationCompliace = [
  {
    link: "importscompliance",
    text: "Import Compliance",
  },
  {
    link: "exportcompliance",
    text: "Export Compliance",
  },
];

// Navigation data for classify
export const navigationClassify = [
  {
    link: "classify",
    text: "HS Code Search",
    subtext: "Get compliance content using HS code or product keyword.",
  },
  // {
  //   link: "classify/schedule-b",
  //   text: "Schedule B"
  // },
  {
    link: "eccn-classification",
    text: "ECCN Search",
    subtext: "Access CCL content using ECCN code or product keyword.",
  },
];

// initial State for searchQuery of Export Compliance
export const initialState = {
  from: 0,
  searchType: "HSCODE",
  countryOfImport: [],
  countryOfExport: [],
  countryOfManufacture: [],
  search: "",
  effectiveDate: getCurrentDate(),
  ecnNumber: "",
  productEndUse: "Non-millitary",
  queryType: "exact",
};

//initial State of export compliance form
export const initialStateForm = {
  country_of_import: "",
  country_of_export: "",
  country_of_origin: "",
  hs_code: "",
  date_of_transaction: getCurrentDate(),
  ecn_number: "",
  product_end_use: "Non-millitary",
};

//Export compliance slice intialState
export const exportComplianceInitialState = {
  exportComplianceState: {
    searchQuery: initialState,
    searchResult: [],
    embargoesResult: [],
    totalCount: 0,
    totalCompliances: 0,
    totalEmbargoes: 0,
  },
  isLoading: true,
  submitButton: false,
  countryOfImport: [],
  countryOfExport: [],
  countryOfOrigin: [],
  formState: initialStateForm,
  paginationState: {
    pageNumber: 1,
    rowPerPage: 10,
  },
};

// classify classification type
export const ClassifyClassificationSelectOptions = [
  {
    value: "import",
    label: "Import",
  },
  {
    value: "export",
    label: "Export",
  },
];

//classify by Eccn classification
export const radioBtnFieldsECCN = [
  {
    name: "ecn_mL_number",
    label: "ECN/ML Number",
  },
  {
    name: "product_keyword",
    label: "Product Keyword",
  },
];

// radio btn for landed cost country hscode form
export const radioBtnFieldsLandedCostCountry = [
  {
    name: "default_duties",
    label: "Default Duties",
  },
  {
    name: "preferential_duties",
    label: "Preferential Duties",
  },
];

// radio btn for landed cost Incoterm form
export const radioBtnFieldsLandedCostIncoterm = [
  {
    name: "sea",
    label: "Sea",
  },
  {
    name: "air",
    label: "Air",
  },
  {
    name: "land",
    label: "Land",
  },
];

// initial state of eccn classification, ecn number search query (API payload)
export const initialStateEcnNumber = {};

// eccn classificaion ecn tab form state
export const intialFormStateECN = {
  country_of_classification: "United States of America",
  hs_code: "",
  date_of_transaction: getCurrentDate(),
  language: "EN",
};

// initial state of eccn classification, product keyword search query (API payload)
export const initialStateEccn = {};

// eccn classificaion product keyword tab form state
export const intialFormStateEccn = {
  country_of_classification: null,
  hs_code: "",
  date_of_transaction: getCurrentDate(),
  language: "EN",
  match_type: "contains",
};

// initial state of eccn classification, ecn number tab
export const eccnClassificationInitialState = {
  //   ecnNumberState:{
  //     searchQuery: initialStateEcnNumber, // API payload
  //     searchResult:[],
  // },
  // ecnNumberFormState: intialFormStateECN,
  eccnState: {
    searchQuery: initialStateEccn, // API payload
    searchResult: [],
  },
  eccnFormState: intialFormStateEccn,
  isLoading: true,
  showMatchType: false,
};

export const complianceConst = {
  DUMMY_FILTER: {
    countryOfImport: [
      { key: "US", doc_count: 100, country_name: "United States" },
      { key: "CA", doc_count: 200, country_name: "Canada" },
      { key: "GB", doc_count: 300, country_name: "United Kingdom" },
      { key: "MX", doc_count: 400, country_name: "Mexico" },
      { key: "BE", doc_count: 100, country_name: "United States1" },
      { key: "BG", doc_count: 100, country_name: "United States2" },
      { key: "DE", doc_count: 100, country_name: "United States3" },
      { key: "AF", doc_count: 100, country_name: "United States4" },
      { key: "ES", doc_count: 100, country_name: "United States5" },
    ],
    countryOfExport: [
      { key: "US", doc_count: 100, country_name: "United States" },
      { key: "CA", doc_count: 200, country_name: "Canada" },
      { key: "GB", doc_count: 300, country_name: "United Kingdom" },
      { key: "MX", doc_count: 400, country_name: "Mexico" },
    ],
    hscode: [
      {
        key: "01",
        description: "Animals",
        values: [
          { key: "010101", description: "bla bla" },
          { key: "010102", description: "bla bla" },
        ],
      },
      {
        key: "02",
        description: "Meat",
        values: [
          { key: "020101", description: "bla bla" },
          { key: "020102", description: "bla bla" },
        ],
      },
    ],
    controllingAuthority: [
      {
        key: "US",
        values: [
          { key: "A1", description: "A1" },
          { key: "A2", description: "A1" },
          { key: "A3", description: "A1" },
        ],
      },
      {
        key: "MX",
        values: [
          { key: "A1", description: "A1" },
          { key: "A2", description: "A1" },
          { key: "A3", description: "A1" },
        ],
      },
      {
        key: "CA",
        values: [
          { key: "A1", description: "A1" },
          { key: "A2", description: "A1" },
          { key: "A3", description: "A1" },
        ],
      },
      {
        key: "GB",
        values: [
          { key: "A1", description: "A1" },
          { key: "A2", description: "A1" },
          { key: "A3", description: "A1" },
        ],
      },
    ],
    controlType: [
      {
        key: "US",
        values: [
          { key: "CT1", description: "CT1" },
          { key: "CT2", description: "CT2" },
          { key: "CT3", description: "CT3" },
        ],
      },
      {
        key: "MX",
        values: [
          { key: "CT1", description: "CT1" },
          { key: "CT2", description: "CT2" },
          { key: "CT3", description: "CT3" },
        ],
      },
      {
        key: "CA",
        values: [
          { key: "CT1", description: "CT1" },
          { key: "CT2", description: "CT2" },
          { key: "CT3", description: "CT3" },
        ],
      },
      {
        key: "GB",
        values: [
          { key: "CT1", description: "CT1" },
          { key: "CT2", description: "CT2" },
          { key: "CT3", description: "CT3" },
        ],
      },
    ],
    data: [
      {
        _id: "yDuMFIMBEGqIYqkalN1I",
        _source: {
          country_of_import: {
            country_iso_code: "US",
            name: "United States of America",
          },
          country_of_manufacture: {
            country_iso_code: "CA",
            name: "Canada",
          },
          country_of_export: {
            country_iso_code: "CA",
            name: "Canada",
          },
          hscode: "6201201110",
          control_type: "Import Permit",
          controlling_authority: "U.S. Fish and Wildlife Service",
          scope_of_control: "Species protected by the Convention on International Trade in Endangered Species of Wild Fauna and Flora (CITES)",
          exceptions: "",
          rates: "",
          notes: "Cites convention",
          reference: "Convention on international trade in endangered species of wild fauna and flora",
          effective_date_from: "2022-01-01",
          status: "A",
          effective_date_to: "2050-12-31",
          updated_in_db_date: "2022-07-04",
          is_taxable: true,
          source_url: "",
        },
      },
    ],
  },
  payload_1st: {
    import: {
      from: 0,
      tradeDirection: "import",
      countryOfImport: [],
      // ["US", "MX","CA","GB",'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'],
      countryOfExport: [],
      hscode: [],
      controllingAuthority: [],
      controlType: [],
      effectiveDate: getCurrentDate(),
      isDefault: true,
      parentLocalFilter: "",
      countryReference: [],
      countryOfOrigin: [],
    },
    export: {
      from: 0,
      tradeDirection: "export",
      countryOfExport: [],
      // ["US", "MX","CA","GB",'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'],
      countryOfImport: [],
      hscode: [],
      controllingAuthority: [],
      controlType: [],
      effectiveDate: getCurrentDate(),
      isDefault: true,
      parentLocalFilter: "",
      countryReference: [],
      countryOfOrigin: [],
    },
  },
};

export const productIdDict = {
  //eu countries
  EU: "European Union",
  EU_NORTHERN: "Northern EU Countries",
  EU_SOUTHERN: "Southern EU Countries",
  EU_EASTERN: "Eastern EU Countries",
  EU_WESTERN: "Western EU Countries",

  //other countries
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  AX: "Åland Islands",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CD: "Congo (the Democratic Republic of the)",
  CG: "Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czechia",
  CI: "Côte d'Ivoire",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran (Islamic Republic of)",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea (the Democratic People's Republic of)",
  KR: "Korea (the Republic of)",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia (Federated States of)",
  MD: "Moldova (the Republic of)",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: "North Macedonia",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine, State of",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  RE: "Réunion",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan (Province of China)",
  TJ: "Tajikistan",
  TZ: "Tanzania, the United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  UM: "United States Minor Outlying Islands",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivarian Republic of)",
  VN: "Vietnam",
  VG: "Virgin Islands (British)",
  VI: "Virgin Islands (U.S.)",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Republic of Kosovo",
  XI: "Northern Ireland (United Kingdom)",
  XC: "Ceuta",
  XL: "Melilla",
};
export const isoCountries = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua And Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia And Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, Democratic Republic",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island & Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic Of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle Of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Korea",
  KW: "Kuwait",
  KP: "Korea (the Democratic People's Republic of)",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States Of",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts And Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre And Miquelon",
  VC: "Saint Vincent And Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome And Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  SS: "South Sudan",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia And Sandwich Isl.",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard And Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad And Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks And Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis And Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  EU: "European Union",
};

export const LandedCostInitialFieldsFOB = [
  {
    label: "Origin Charges",
    key: "origin_charges",
    required: false,
    placeholder: "Enter Origin Charges",
    desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
  },
  {
    label: "Origin Freight",
    key: "origin_freight",
    required: false,
    placeholder: "Enter Origin Freight",
    desc: "Costs for transporting goods from the seller’s location to the port of departure.",
  },
  { label: "Insurance Charges", key: "insurance", required: false, placeholder: "Enter Insurance Charges", desc: "Cost of insuring goods against loss or damage during transit." },
  {
    label: "International Freight",
    key: "freight",
    required: false,
    placeholder: "Enter International Freight",
    desc: "Expenses for transporting goods from the origin port to the destination port.",
  },
  {
    label: "Destination Charges",
    key: "destination_charges",
    required: false,
    placeholder: "Enter Destination Charges",
    desc: "Fees incurred at the destination port, including unloading and customs clearance.",
  },
  {
    label: "Destination Freight",
    key: "destination_freight",
    required: false,
    placeholder: "Enter Destination Freight",
    desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
  },
];

export const LandedCostFieldsFOB = {
  CFR: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  CIF: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  CIP: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges*",
      key: "destination_charges",
      required: true,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  CPT: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  DAP: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  DDP: [
    {
      label: "Origin Charges",
      key: "origin_charges",
      required: false,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "Origin Freight",
      key: "origin_freight",
      required: false,
      placeholder: "Enter Origin Freight",
      desc: "Costs for transporting goods from the seller’s location to the port of departure.",
    },
    {
      label: "International Freight",
      key: "freight",
      required: false,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  DPU: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight*",
      key: "destination_freight",
      required: true,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges*",
      key: "destination_charges",
      required: true,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  EXW: [
    {
      label: "Origin Charges*",
      key: "origin_charges",
      required: true,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "Origin Freight*",
      key: "origin_freight",
      required: true,
      placeholder: "Enter Origin Freight",
      desc: "Costs for transporting goods from the seller’s location to the port of departure.",
    },
    {
      label: "International Freight",
      key: "freight",
      required: false,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  FAS: [
    {
      label: "Origin Charges*",
      key: "origin_charges",
      required: true,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "International Freight",
      key: "freight",
      required: false,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  FCA: [
    {
      label: "Origin Charges*",
      key: "origin_charges",
      required: true,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "International Freight",
      key: "freight",
      required: false,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  FOB: [
    {
      label: "International Freight",
      key: "freight",
      required: false,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
};
export const LandedCostFieldsCIF = {
  CFR: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  CIF: [
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  CIP: [
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges*",
      key: "destination_charges",
      required: true,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  CPT: [
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  DAP: [
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  DDP: [
    {
      label: "Insurance Charges",
      key: "insurance",
      required: false,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
    {
      label: "Origin Charges",
      key: "origin_charges",
      required: false,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "Origin Freight",
      key: "origin_freight",
      required: false,
      placeholder: "Enter Origin Freight",
      desc: "Costs for transporting goods from the seller’s location to the port of departure.",
    },
    {
      label: "International Freight",
      key: "freight",
      required: false,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
  ],
  DPU: [
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight*",
      key: "destination_freight",
      required: true,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges*",
      key: "destination_charges",
      required: true,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  EXW: [
    {
      label: "Origin Charges*",
      key: "origin_charges",
      required: true,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "Origin Freight*",
      key: "origin_freight",
      required: true,
      placeholder: "Enter Origin Freight",
      desc: "Costs for transporting goods from the seller’s location to the port of departure.",
    },
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  FAS: [
    {
      label: "Origin Charges*",
      key: "origin_charges",
      required: true,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  FCA: [
    {
      label: "Origin Charges*",
      key: "origin_charges",
      required: true,
      placeholder: "Enter Origin Charges",
      desc: "Fees incurred at the starting point of the shipment, including handling and documentation.",
    },
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
  FOB: [
    {
      label: "International Freight*",
      key: "freight",
      required: true,
      placeholder: "Enter International Freight",
      desc: "Expenses for transporting goods from the origin port to the destination port.",
    },
    {
      label: "Insurance Charges*",
      key: "insurance",
      required: true,
      placeholder: "Enter Insurance Charges",
      desc: "Cost of insuring goods against loss or damage during transit.",
    },
    {
      label: "Destination Freight",
      key: "destination_freight",
      required: false,
      placeholder: "Enter Destination Freight",
      desc: "Costs for transporting goods from the destination port to the buyer’s specified location.",
    },
    {
      label: "Destination Charges",
      key: "destination_charges",
      required: false,
      placeholder: "Enter Destination Charges",
      desc: "Fees incurred at the destination port, including unloading and customs clearance.",
    },
  ],
};

export const excludeRulings = {
  CH: true,
  MY: true,
  SG: true,
  IN: true,
  MX: true,
  AU: true,
  ID: true,
  SA: true,
  TW: true,
  ZA: true,
  NA: true,
  SZ: true,
  LS: true,
  BW: true,
};
export const includeBillOfLadding = {
  US: true,
  MX: true,
};
export const incotermsFullForm = {
  CFR: "Cost & Freight",
  CIF: "Cost , Insurance & Freight",
  CIP: "Carriage & Insurance Paid to",
  CPT: "Carriage Paid to",
  DAP: "Delivered At Place",
  DDP: "Delivered Duty Paid",
  DPU: "Delivered At Place Unloaded",
  EXW: "EX-Works",
  FAS: "Free Alongside Ship",
  FCA: "Free Carriers",
  FOB: "Free On Board",
};

export const unifiedIsoCountries = {
  ALL: "All Countries",
  UK: "United Kindom",
  EU: "European Union",
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  AX: "Åland Islands",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CD: "Congo (the Democratic Republic of the)",
  CG: "Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czechia",
  CI: "Côte d'Ivoire",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran (Islamic Republic of)",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea (the Democratic People's Republic of)",
  KR: "Korea (the Republic of)",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia (Federated States of)",
  MD: "Moldova (the Republic of)",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: "North Macedonia",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PW: "Palau",
  PS: "Palestine, State of",
  PA: "Panama",
  PG: "Papua New Guinea",
  PK: "Pakistan",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  RE: "Réunion",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan (Province of China)",
  TJ: "Tajikistan",
  TZ: "Tanzania, the United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  UM: "United States Minor Outlying Islands",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivarian Republic of)",
  VN: "Vietnam",
  VG: "Virgin Islands (British)",
  VI: "Virgin Islands (U.S.)",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Republic of Kosovo",
  XI: "Northern Ireland (United Kingdom)",
  XC: "Ceuta",
  XL: "Melilla",
  //PROVIENCE COUNTRIES
  ALB: "Alberta",
  BRC: "British Columbia",
  MAN: "Manitoba",
  NEB: "New Brunswick",
  NEL: "Newfoundland and Labrador",
  NOT: "Northwest Territories",
  NOS: "Nova Scotia",
  NUN: "Nunavut",
  ONT: "Ontario",
  PEI: "Prince Edward Island",
  QUC: "Quebec",
  SAK: "Saskatchewan",
  YUT: "Yukon",
};

export const countryOptions = Object.entries(unifiedIsoCountries).map(([value, label]) => ({
  value,
  label,
}));

export const unifiedTabs = {
  "Tariffs and Duties": "Tariffs and Duties",
  Controls: "Controls",
  Rulings: "Rulings",
};

export const EUcountryList = [
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "HU",
  "IE",
  "IT",
  "LT",
  "LU",
  "LV",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SE",
  "SI",
  "SK",
];

export const HSModule = {
  controls: "controls",
  classify: "classify",
  scheduleb: "scheduleb",
};
export const HSModuleType = {
  import: "import",
  export: "export",
};

export const HSModuleClassificationType = {
  PRODUCT_KEYWORD: "PRODUCT_KEYWORD",
};

export const redirectToAccessiblePath = (accessObj = {}) => {
  for (const parent of [...gtcTabsEnum.upperTabs, ...gtcTabsEnum.bottomTabs]) {
    for (const child of parent.subItem || []) {
      if (child.accessKey && accessObj[child.accessKey]) {
        return child.link;
      }
    }
  }
  return "/classify";
};

export const notificatonStatusEnum = {
  read: "read",
  unread: "unread",
};

export const notificatonActionEnum = {
  markRead: "mark_read",
  markAllRead: "mark_all_read",
  clearAllRead: "clear_all_read",
};

export const isLandedCost =
  window.location.pathname.includes("landedcostcalculator") || window.location.pathname.includes("compare-tariff") || window.location.search.includes("landedcostcalculator");

export const INTERNAL_ACCESS_EMAILS = ["pramodsant2601@gmail.com", "peter.goossens@intertrans.eu", "tamara.neckebroek@intertrans.eu", "luc.havermans@intertrans.eu"];

export const isInternalUser = (email = "") => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase();
  return normalizedEmail.includes("trademo.com") || INTERNAL_ACCESS_EMAILS.includes(normalizedEmail);
};

export const TAG_MAX_LENGTH = 15;
